module.exports = __webpack_public_path__ + "static/media/sidebar-dark.17840c72.png";